module.exports = "pegasus_template/assets/theme5/l_d.png";